import TbhLogoWithText from '../common/TbhLogoWithText';
import '../App.css';
import SetSecurityQuestions from '../features/securityQuestion/SetSecurityQuestions';
import AuthWrapper from '../components_/layout/AuthWrapper';

const SecurityQuestionPage = () => {
  return (
    <AuthWrapper>
      <SetSecurityQuestions />
    </AuthWrapper>
  );
};

export default SecurityQuestionPage;
